export default "__VITE_ASSET__Ca14GJdA__"